const SVGComponent = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    fill="none"
  >
    <path
      d="M10 6.25V5.41667M10 13.75V14.5833M11.8046 7.5C11.4444 7.00183 10.7711 6.66667 10 6.66667H9.76852C8.74577 6.66667 7.91667 7.32995 7.91667 8.14815V8.21175C7.91667 8.79699 8.32998 9.33199 8.98429 9.59372L11.0157 10.4063C11.67 10.668 12.0833 11.203 12.0833 11.7882C12.0833 12.6416 11.2186 13.3333 10.152 13.3333H10C9.22887 13.3333 8.5556 12.9982 8.19538 12.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SVGComponent
